// ./src/components/inputs/InputCheckBox/styles.ts
import { Radio, RadioGroup } from '@material-ui/core';
import styled from 'styled-components';

export const Container = styled.div``;

export const Label = styled(RadioGroup)``;

export const RadioInput = styled(Radio)``;
